import { useCallback } from 'react';
import useState from '../useStateIfMounted/useStateIfMounted';
import type { UseAsyncLoading } from './types';

const useAsyncLoading: UseAsyncLoading = ({ func, onError, onSuccess }, deps) => {
  const [loading, setLoading] = useState(false);

  const [error, setError] = useState<undefined | Error>(undefined);

  const wrappedFunc = useCallback(
    async (...args: any[]) => {
      if (!func) {
        return;
      }

      setLoading(true);

      let res;

      try {
        res = (await func?.(...args)) as Awaited<ReturnType<typeof func>>;

        onSuccess?.(res);
      } catch (e: any) {
        setError(e);

        onError?.(e);
      } finally {
        setLoading(false);
      }

      return res;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    deps ?? [func]
  );

  return [wrappedFunc as NonNullable<typeof func>, loading, error];
};

export default useAsyncLoading;
